export default __webpack_public_path__ + "static/ramanSharma3-e9e978faa86115eb05ce723dacfdf313.jpg";